import { IDS } from "@/constants/testIds";
import { OWNER, EXPERIENCE, SKILLS } from "@/data/content";

export default function About() {
  return (
    <section
      id="about"
      data-testid={IDS.about.root}
      className="border-b border-border py-24"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <div className="flex items-center gap-3 font-jet text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-8">
          <span>01</span><span className="h-px w-8 bg-border"></span><span>About</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <div className="md:col-span-7">
            <h2 className="font-mono-brut font-black uppercase text-3xl sm:text-5xl tracking-tighter leading-none">
              I ship <span className="text-[#E3FF00]">products</span>,
              <br />not tickets.
            </h2>
            <p className="mt-8 text-base sm:text-lg text-foreground/80 leading-relaxed max-w-2xl">
              {OWNER.bio}
            </p>
            <p className="mt-4 text-base text-foreground/60 leading-relaxed max-w-2xl">
              I care about the whole loop - from database schemas to landing-page conversion.
              I&apos;ve scaled apps to 10,000+ users, migrated legacy Bubble backends into React + TypeScript,
              and shipped features that pay rent for founders.
            </p>

            {/* Skills */}
            <div className="mt-8 flex flex-wrap gap-2">
              {SKILLS.map((s) => (
                <span
                  key={s}
                  className="font-jet text-[11px] uppercase tracking-widest border border-border px-3 py-1.5 hover:border-[#E3FF00] hover:text-[#E3FF00] transition"
                >
                  {s}
                </span>
              ))}
            </div>
          </div>

          {/* Experience timeline */}
          <div className="md:col-span-5">
            <div className="border border-border bg-[#141414]">
              <div className="border-b border-border px-4 py-3 flex items-center justify-between">
                <span className="font-jet text-[11px] uppercase tracking-widest">Experience</span>
                <span className="font-jet text-[11px] text-muted-foreground">{EXPERIENCE.length} roles</span>
              </div>
              <ul>
                {EXPERIENCE.map((e, i) => (
                  <li
                    key={i}
                    className="px-4 py-4 border-b border-border last:border-b-0 hover:bg-[#1F1F1F] transition group"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <div className="font-mono-brut text-sm font-bold group-hover:text-[#E3FF00]">{e.role}</div>
                        <div className="font-jet text-[11px] text-muted-foreground mt-1">{e.org}</div>
                      </div>
                      <div className="font-jet text-[10px] uppercase tracking-widest text-muted-foreground whitespace-nowrap">{e.years}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
